import { render } from "./Assignment5.vue?vue&type=template&id=77587473"
import script from "./Assignment5.vue?vue&type=script&lang=js"
export * from "./Assignment5.vue?vue&type=script&lang=js"

import exportComponent from "/Users/engkhiongsoh/dev/marketanalysis/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__